/**
 * 模块接口
 */
import { get, post } from '@http/request'
import qs from 'qs'

/**
 * 工作台
 */
export const reqTodayCount = (params) => get(`vip/data/today/count`, params)
export const reqTotalCount = (params) => get(`vip/data/total/count`, params)

/**
* 用户管理
*/
// 新增用户
export const addNewUser = (params) => post(`/vip/user/save`, params)
// 用户详情
export const UserDetail = (params) => get(`/vip/user/detail`, params)

// 修改用户 /  切换用户状态
export const UserUpdate = (params) => post(`/vip/user/update`, params)
// 删除用户
export const UserDelete = (params) => post(`/vip/user/delete`, qs.stringify(params))

// 用户列表
export const reqUserList = (params) => get(`/vip/user/page`, params)

// 地址列表
export const reqAddressList = (params) => get(`/vip/address/page`, params)
// 校验省市区是否开通
export const checkArea = (params) => post(`/vip/area/check`, qs.stringify(params), { 'content-type': 'application/x-www-form-urlencoded' })
// 新增地址
export const addAddress = (params) => post(`/vip/address/add`, params)
// 修改地址
export const updateAddress = (params) => post(`/vip/address/update`, params)
// 删除地址
export const delAddress = (params) => post(`/vip/address/delete`, params)
// 获取默认地址
export const getDefaultAddress = (params) => get(`/vip/address/getDefaultAddress`, params)
// 获取地址模板
export const downloadAddressTemplate = () => post(`/vip/address/downloadTemplate`, '', { responseType: 'blob' })

// 新下载模板 20201209新增
export const downloadTemplateNew = (params) => post(`/vip/excel/downloadTemplate`, params, { responseType: 'blob' })

// 物流信息-快件跟踪（单个）
export const getDetailByWaybillNo = (params) => get(`/vip/logisticsTracking/getDetailByWaybillNo`, params)

//  物流信息-快件跟踪（批量查询）
// export const getDetailByWaybillNos = (params) => get(`/vip/logisticsTracking/getDetailByWaybillNos`, params)
export const getDetailByWaybillNos = (reqData) => post(`/vip/logisticsTracking/v2/getDetailByWaybillNo`, reqData)

//  物流信息-签收图片
// export const getDetailByWaybillNos = (params) => get(`/vip/logisticsTracking/getDetailByWaybillNos`, params)
export const listImagePath = (reqData) => post(`/vip/logisticsTracking/listImagePath`, reqData)

// oss 图片链接
export const signedUrl = (reqData) => post(`/vip/file/download/signed/url/`, reqData)

//  运费计算
// export const freightCalculation = (params) => post(`/vip/costCalculation/spmCustomerShippingQuote/comCost`, params)

//  通过省市区匹配结算目的地
export const getSettlement = (params) => post(`/vip/area/getSettlementDestinationByProvinceCityAreaId`, params)

// 单票下单：新增订单
export const vipOrderAdd = (reqData) => post(`/vip/order/add`, reqData)

// 单票下单：运费计算
export const getComCost = (reqData) => post(`/vip/costCalculation/spmCustomerShippingQuote/comCost`, reqData)

// 单票下单：保价费计算
export const getComputationCost = (reqData) => post(`/vip/costCalculation/insuranceFee/computationCost`, reqData)

// 燃油费费率查询
export const getfuelCost = () => get(`/vip/network/getProxyNetworkByCode`)

// 保价费计算（批量）
export const getcomCostBatch = (reqData) => post(`/vip/costCalculation/insuranceFee/comCostBatch`, reqData)

// 单票下单：综合拉取基础数据
export const getList = () => get(`/vip/baseData/list`)

// 单票下单：列表带分页
export const addressPage = (params) => get(`/vip/address/page`, params)

// 单票下单：新增地址
export const addressAdd = (reqData) => post(`/vip/address/add`, reqData)

// 运单：运单列表
export const waybillOrder = (params) => post(`/vip/waybillOrder/page`, params)

// 运单：运单状态数据统计
export const countByStatus = (params) => post(`/vip/waybillOrder/countByStatus`, params)

// 运单：运单导出
export const waybillExport = (reqData) => post(`/vip/waybillOrder/export`, reqData, { responseType: 'arraybuffer' })
// 运单：异步运单导出
export const asyExportWaybill = (reqData) => post(`/vip/waybillOrder/asyExport`, reqData)

// 运单：运单删除
export const waybillDelete = (reqData) => post(`/vip/waybillOrder/delete`, qs.stringify(reqData))

// 运单：运单详情
export const getDetailById = (params) => get(`/vip/waybillOrder/getDetailByNo`, params)

// 运单：根据运单号查询退件登记时间
export const getRebackExpress = (params) => get(`/vip/waybillOrder/getRebackExpress`, params)

// 订单：订单列表
export const orderList = (reqData) => post(`/vip/order/list`, reqData)

// 订单：订单状态分组统计总数
export const orderTotalGroup = (reqData) => post(`/vip/order/totalGroup`, reqData)

// 订单：修改订单
export const orderUpdate = (reqData) => post(`/vip/order/update`, reqData)

// 订单：合并订单
export const orderMerge = (reqData) => post(`/vip/order/merger`, reqData)

// 订单：订单详情
export const detailOrder = (params) => get(`/vip/order/detailOrder`, params)

// 订单：订单导出
export const regularOutputExcel = (reqData) => post(`/vip/order/regularOutputExcel`, reqData, { responseType: 'arraybuffer' })
// 订单：订单异步导出
export const asyExportOrder = (reqData) => post(`/vip/order/asyExportOrder`, reqData)

// 订单：删除订单
export const orderrDelete = (reqData) => post(`/vip/order/delete?orderId=${reqData.orderId}`)

// 订单：订单子单打印
// export const printOrders = (params) => get(`/vip/order/printOrders`, params)
export const printOrders = (reqData) => post(`/vip/order/newPrintOrders`, reqData, { responseType: 'arraybuffer' })

// 订单：订单子单打印 url
export const printOrderUrl = (reqData) => post(`/vip/order/orderPrintUrl`, reqData)

// 订单取消
export const orderCancel = (params) => post(`/vip/order/cancel`, params)

// 子订单查询
export const subOrderList = (params) => get(`/vip/order/subOrderList`, params)

// 子订单打印
export const printOrderSubs = (params) => get(`/vip/order/printOrderSubs`, params)

// 批量删除订单
export const orderBatchDelete = reqData => post(`/vip/order/batchDelete`, reqData)

/**
* 批量下单
*/
// 订单列表

// 下载模板
export const downloadTemplate = (typeTemplate) => post(`/vip/order/${typeTemplate}`, '', { responseType: 'blob' })

// 更新下载状态
export const updateFinishDownLoad = (params) => post(`/vip/exportRecord/updateFinishDownLoad`, params)

// 批量导入
export const excelImport = (params) => post(`/vip/order/excelImport`, params)
// 批量新增订单
export const batchAdd = (params) => post(`/vip/order/batchAdd`, params)
// 批量取消订单
export const cancel = (params) => post(`/vip/order/cancel`, params)
// 客户订单号验重
export const checkRepeatCustomerOrderId = (params) => post(`/vip/order/checkRepeatCustomerOrderId`, params)

// 订单来源
export const queryCustomerOrderSource = (params) => get(`/vip/orderSource/order`, params)

// 匹配客户手动输入的地址
export const queryAddressAnalysisAddress = (params) => get(`/vip/address/analysisAddress`, params)

// 获取回单金额
export const getReceiptFee = (params) => get(`/vip/order/getReceiptFeeByCode`, params)

// 下载中心列表
export const downloadCenterList = (params) => post(`/vip/exportRecord/page`, params)
// 下载中心列表删除
export const downloadCenterReqDel = (reqData) => post(`/vip/exportRecord/delete`, reqData)

// 订单：订单列表-三方下单
export const orderListThridNo = (reqData) => post(`/vip/thridOrder/noOrderlist`, reqData)

// 订单：三方下单分组统计总数
export const orderTotalGroupThridNo = (reqData) => post(`/vip/thridOrder/noOrderTotalGroup`, reqData)

// 订单：订单列表-三方下单-立即下单
export const batchSave = (reqData) => post(`/vip/thridOrder/batchSave`, reqData)

// 订单：订单列表-三方下单-取消订单
export const cancelById = (reqData) => post(`/vip/shopify/order/cancle`, reqData)

// 同步shopify信息
export const shopifyOrderSync = (params) => get(`/vip/shopify/order/sync`, params)

// shopify 仓库地址
export const shopifyAddressList = (params) => get(`/vip/shopify/address/list`, params)

// shopify 批量修改地址
export const shopifyOrderAddrUpdate = (params) => post(`/vip/shopify/order/orderAddrUpdate`, params)

// shopify store list
export const shopifyMyStore = (params) => get(`/vip/shopify/myStore`, params)

// 获取币别
export const getsysCurrencyType = (params) => get(`/vip/sysCurrencyType/list`, params)

// 单票下单：是否代收货款
export const customerCod = (params) => get(`/vip/network/customerCod`, params)
// 单票下单：是否代收货款
export const httpQueryCod = (params) => post(`/vip/costCalculation/getCodFee`, params)
// 批量下单下载地址
export const downloadExcelAddressTemplate = () => post(`/vip/excel/downloadAddressTemplate`, '', { responseType: 'blob' })
